<template>
  <div class="legal-page">
    <router-link to="/" class="back-link">
      <span class="material-icons">arrow_back</span>
      {{ $t('legal.backToHome') }}
    </router-link>
    <h1>{{ $t('legal.privacy.title') }}</h1>
    <p class="last-updated">{{ $t('legal.privacy.lastUpdated') }}</p>

    <h2>{{ $t('legal.privacy.intro.title') }}</h2>
    <p>{{ $t('legal.privacy.intro.content') }}</p>

    <h2>{{ $t('legal.privacy.collection.title') }}</h2>
    <p>{{ $t('legal.privacy.collection.content') }}</p>

    <h2>{{ $t('legal.privacy.usage.title') }}</h2>
    <p>{{ $t('legal.privacy.usage.content') }}</p>

    <h2>{{ $t('legal.privacy.storage.title') }}</h2>
    <p>{{ $t('legal.privacy.storage.content') }}</p>

    <h2>{{ $t('legal.privacy.thirdParty.title') }}</h2>
    <p>{{ $t('legal.privacy.thirdParty.content') }}</p>

    <h2>{{ $t('legal.privacy.cookies.title') }}</h2>
    <p>{{ $t('legal.privacy.cookies.content') }}</p>

    <h2>{{ $t('legal.privacy.rights.title') }}</h2>
    <p>{{ $t('legal.privacy.rights.content', { email: 'goodscriber@gmail.com' }) }}</p>

    <h2>{{ $t('legal.privacy.children.title') }}</h2>
    <p>{{ $t('legal.privacy.children.content') }}</p>

    <h2>{{ $t('legal.privacy.changes.title') }}</h2>
    <p>{{ $t('legal.privacy.changes.content') }}</p>

    <h2>{{ $t('legal.privacy.contact.title') }}</h2>
    <p>{{ $t('legal.privacy.contact.content', { email: 'goodscriber@gmail.com' }) }}</p>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy'
}
</script>

<style>
@import '../../styles/legal.css';
</style>
